export default __webpack_public_path__ + "static/media/1-6-3.299fe622.jpg";